
    module.exports = function cssToMuiLoader(theme) {
      
      return {
        
        'boldStyle': {'fontWeight': `bold`,},'row': {'width': `100%`,'display': `flex`,'justifyContent': `space-between`,},'infoWindowColumnOne': {'textAlign': `left`,},'infoWindowColumnTwo': {'textAlign': `right`,'margin': `0px 16px 0px 16px`,},'icon': {'fontSize': `small`,},'infoWindow': {'fontSize': `x-small`,'paddingRight': `16px`,},
        
      };
    };
  